export default "__VITE_ASSET__CeB6BIol__"